<template>
  <div class="home-scroll w1200 mt10">
    <superslide :options="options" class="slideBox">
      <div class="bd">
        <ul>
          <div class="tempWrap" style="overflow:hidden; position:relative; width:1205px">
            <li style="width: 1928px; left: -723px; position: relative; overflow: hidden; padding: 0px; margin: 0px;">
              <a v-for="(item, index) in brand_list" :key="index" href="javascript:void(0)" title=""
                style="float: left; width: 236px;">
                <router-link :to="{
                  path: '/good/list',
                  query: { sid: item.id, type: 2 },
                }">
                  <img mode="aspectFill" class="lazyload" :data-original="item.logo" style="display: inline;"
                    :src="item.logo" />
                </router-link>

              </a>
            </li>
          </div>
        </ul>
        <a class="ctrl prev" href="javascript:void(0)">&lt;</a>
        <a class="ctrl next" href="javascript:void(0)">&gt;</a>
      </div>
    </superslide>
  </div>
</template>

<script>
  import '@/assets/styles/index.css';
  import "@/assets/plugins/jquery.SuperSlide.2.1.1.js";
  import {
    brand_list
  } from "@/api/store";
  import Vue from "vue";
  import VueSuperSlide from "vue-superslide";
  Vue.use(VueSuperSlide);
  export default {
    name: "StoreStreet",
    data() {
      return {
        brand_list: [],
      };
    },
    methods: {},
    mounted() {
      var that = this;
      if (
        !localStorage.getItem("brand_list") ||
        localStorage.getItem("brand_list") == "undefined"
      ) {
        brand_list().then((res) => {
          that.brand_list = res.data.brand_list;
          localStorage.setItem("brand_list", JSON.stringify(that.brand_list));
        });
      } else {
        that.brand_list = JSON.parse(localStorage.getItem("brand_list"));
      }
      if (that.brand_list.length > 0) {
        that.$nextTick(function () {
          jQuery(".home-scroll").slide({
            mainCell: ".bd li",
            autoPage: false,
            autoPlay: false,
            delayTime: 5000,
            effect: "left",
            interTime: 2000,
            vis: 5,
          });
        });
      }
    },
    watch: {},
  };
</script>

<style scoped>
  .home-scroll ul li a {
    text-align: center;
  }

  .home-scroll ul li a img {
    width: 150px;
    height: auto;
  }
</style>
